var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',_vm._b({staticClass:"tile-card"},'v-col',_vm.cols,false),[(_vm.loading)?[_c('tile-card',{attrs:{"default-actions":false}},[_c('v-card-text',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"color":"ocean","indeterminate":""}})],1)],1)]:_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }